import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

export const GET_PROVIDER = gql`
        query getProvider($providerId: String, $carrierId: String!, $planId: String!, $locationId: String) {
            provider(id: $providerId){
                id
                acceptsInsurance(carrierId: $carrierId, planId: $planId, locationId: $locationId)
            }
        }
    `;

export default graphql(GET_PROVIDER, {
    skip: ownProps => {
        return !ownProps.providerId
            || !ownProps.carrierId
            || !ownProps.planId
            || ownProps.planId === '-1';
    },
    options: ownProps => ({
        ssr: true,
        variables: {
            carrierId: ownProps.carrierId,
            locationId: ownProps.locationId,
            planId: ownProps.planId,
            providerId: ownProps.providerId,
        },
        notifyOnNetworkStatusChange: true,
    }),
    props: ({ data }) => {
        if (data.loading) return { insuranceIsValidating: true };
        if (data.error) return;

        return {
            insuranceIsAccepted: data.provider.acceptsInsurance,
            insuranceIsValidating: false,
        };
    },
});
